import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface VwBulkAction {
  key: string;
  label: string;
  icon?: string;
  danger?: boolean;
}

// Presentational floating toolbar that appears once a list's selection is
// non-empty — the parent owns the actual selection Set and the handler for
// whichever action key comes back through actionClick, this component only
// renders the count/buttons.
@Component({
  selector: 'app-bulk-actions-bar',
  templateUrl: 'bulk-actions-bar.component.html',
  styleUrls: ['bulk-actions-bar.component.scss']
})
export class BulkActionsBarComponent {
  @Input() count = 0;
  @Input() actions: VwBulkAction[] = [];
  @Output() actionClick = new EventEmitter<string>();
  @Output() clear = new EventEmitter<void>();
}
